// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","ul":"Footer_ul__F7CXb","statement":"Footer_statement__2towV","buttonTop":"Footer_buttonTop__0xjKO","contrast":"Footer_contrast__TTKMU"};